import { useEffect, useState, } from 'react';
import theme from '../../styles/theme';
import windowMatchMedia from '../../utils/windowMatchMedia';
const breakpointRanges = (theme
    .breakpointsList
    .map(({ breakpointName, breakpointValue, }, index, breakpointEntries) => ({
    breakpointName,
    maximumValue: ((breakpointEntries[index + 1] || {})
        .breakpointValue),
    minimumValue: breakpointValue,
}))
    .reduce((combinedBreakpointRanges, { breakpointName, maximumValue, minimumValue, }) => (Object.assign(Object.assign({}, combinedBreakpointRanges), { [breakpointName]: {
        maximumValue,
        minimumValue,
    } })), {}));
export const mediaQueryStates = {
    ABOVE: 'ABOVE',
    AT: 'AT',
    BELOW: 'BELOW',
    UNKNOWN: 'UNKNOWN',
};
const useMediaQueryState = ({ localWindow = (typeof window === 'undefined'
    ? undefined
    : window), mediaQuerySize, }) => {
    const [mediaQueryState, setMediaQueryStates,] = useState(mediaQueryStates.UNKNOWN);
    useEffect(() => {
        var _a, _b;
        if (mediaQuerySize === undefined) {
            return;
        }
        const maximumValue = ((_a = breakpointRanges[mediaQuerySize]) === null || _a === void 0 ? void 0 : _a.maximumValue);
        const minimumValue = (((_b = breakpointRanges[mediaQuerySize]) === null || _b === void 0 ? void 0 : _b.minimumValue)
            || 0);
        const mediaQueries = ([
            maximumValue
                && {
                    callback: ({ matches, }) => {
                        if (matches) {
                            setMediaQueryStates(mediaQueryStates.ABOVE);
                        }
                    },
                    mediaQuery: (localWindow === null || localWindow === void 0 ? void 0 : localWindow.matchMedia(`(min-width: ${maximumValue}px)`)),
                },
            maximumValue
                && {
                    callback: ({ matches, }) => {
                        if (matches) {
                            setMediaQueryStates(mediaQueryStates.AT);
                        }
                    },
                    mediaQuery: (localWindow === null || localWindow === void 0 ? void 0 : localWindow.matchMedia(`(min-width: ${minimumValue}px)`
                        .concat(' and ')
                        .concat(`(max-width: ${maximumValue - 1}px)`))),
                },
            {
                callback: ({ matches, }) => {
                    if (matches) {
                        setMediaQueryStates(mediaQueryStates.BELOW);
                    }
                },
                mediaQuery: (localWindow === null || localWindow === void 0 ? void 0 : localWindow.matchMedia(`(max-width: ${minimumValue - 1}px)`)),
            },
        ]
            .filter(Boolean));
        mediaQueries
            .forEach((query) => {
            if (!query
                || query.callback === undefined
                || query.mediaQuery === undefined) {
                return;
            }
            const { callback, mediaQuery, } = query;
            windowMatchMedia.addListener(mediaQuery, callback);
            callback(mediaQuery);
        });
        return () => {
            mediaQueries
                .forEach((query) => {
                if (!query
                    || query.callback === undefined
                    || query.mediaQuery === undefined) {
                    return;
                }
                const { callback, mediaQuery, } = query;
                windowMatchMedia.removeListener(mediaQuery, callback);
            });
        };
    }, [
        localWindow,
        mediaQuerySize,
    ]);
    return mediaQueryState;
};
useMediaQueryState.mediaQueryStates = mediaQueryStates;
export default useMediaQueryState;
